// extracted by mini-css-extract-plugin
export default {"gitStats":"GitHub_gitStats__-4I5M","box3":"GitHub_box3__gcVR2"};